import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import { CommonButton } from '../../../../Styles/CommonStyles';
import { useUpdateassetReqMutation } from '../../../../features/assetrequest/assetReqApiSlice';
import nameStringFn from '../../../../data/nameStringFn';

// Styled Components
const Button = styled(CommonButton)`
  padding: 8px 16px;
  min-width: 120px;
  margin-right: 10px;
`;

const ActionButton = styled(Button)`
  background-color: #1976d2;
`;

const RemarkContainer = styled.div`
  margin-top: 15px;
  width: 100%;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  align-self: flex-start;
`;

const UserReturnInboxForm = ({ 
  row, 
  remark, 
  setRemark, 
  handleModifySelection, 
  isModificationRequest,
  auth,
  user_current_office,
  getSingleuser,
  handleBack,
  BO_id,
  selectedAssets
}) => {
  const [updateReq, { isLoading: updateLoading }] = useUpdateassetReqMutation();
  const [field, setField] = useState([]);
  

  useEffect(() => {
      if (!selectedAssets || !selectedAssets?.length) return
      setField(prev => {
        const newFields = [...prev]
        selectedAssets.forEach(x => {
          const exists = newFields.some(elm => elm.oem_tag === x.oem_tag);
          if (!exists) {
            newFields.push({
              id:x.id,
              oem_tag: x.oem_tag,
              assetName: x.name,
              spec: x.specification,
              pur_date: x.purchase_date,
              wrty_date: x.warrantyexp_date
            })
          }
        })
        return newFields;
      })
    },[selectedAssets])

  const handleRemodifyRequest = async () => {
    if (!remark.trim()) {
      alert("Please provide a remark before resubmitting");
      return;
    }

    if (selectedAssets.length === 0) {
      // If selectedAssets is empty, suggest modification
      handleModifySelection();
      return;
    }

    // Create a new asset request object with modified assets
    const newAssetRequest = {
      time_stamp: new Date(),
      actionNo: (row?.assets_requested?.length + 1) || 1,
      data: field
    };

    const senttoData = {
      sent_to_tag: "user_resubmit_return",
      Text: remark,
      action: "Return Request Resubmitted After Modification",
      sent_by: { 
        id: auth?.id, 
        name: getSingleuser?.[auth?.id]?.name, 
        office: user_current_office, 
        designation: auth?.designation?.[user_current_office] 
      },
      sent_to: { 
        id: BO_id, 
        name: getSingleuser?.[BO_id]?.name, 
        office: user_current_office, 
        designation: getSingleuser?.[BO_id]?.designation?.[user_current_office] 
      },
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[BO_id])}-${user_current_office}-${getSingleuser?.[BO_id]?.designation?.[user_current_office] || 'Unknown'}`,
      time_stamp: new Date(),
      assets_requested: newAssetRequest
    };

    const body = { id: row?._id, senttoData: senttoData };
    
    try {
      await updateReq(body);
      alert("Return request has been resubmitted to BO with modified assets.");
      handleBack();
    } catch (error) {
      console.error("Error resubmitting request:", error);
      alert("Error resubmitting request. Please try again.");
    }
  };

  return (
    <>
      {/* Asset Summary Table is in the main component */}
      
      <RemarkContainer>
        <TextField
          label="Remarks"
          multiline
          rows={4}
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          fullWidth
        />
      </RemarkContainer>

      {/* User Actions - For resubmission after modification */}
      {isModificationRequest && (
        <ButtonsWrapper>
          <ActionButton onClick={handleRemodifyRequest}>
            Resubmit to BO
          </ActionButton>
        </ButtonsWrapper>
      )}
    </>
  );
};

export default UserReturnInboxForm; 